<!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
@if (!this.isIframe && this.me.sessionSignal()) {

<view-sidenav></view-sidenav>

}